// extracted by mini-css-extract-plugin
export var marginNegative = "_5w-5 _5w-3 _5w-1";
export var marginPositive = "_5w-4 _5w-3 _5w-1";
export var modalContent = "_5w-6";
export var samplesTable = "_5w-8";
export var samplesTableContainer = "_5w-7";
export var statBox = "_5w-a";
export var tableCell = "_5w-1";
export var tableCellCenter = "_5w-2 _5w-1";
export var tableCellRight = "_5w-3 _5w-1";
export var tableHeader = "_5w-0";
export var trackingNumber = "_5w-9";